import React from 'react'
import PropTypes from 'prop-types'
import { truncate } from 'helpers/util'
import SubwayRow from 'components/listings/cards/components/SubwayRow'

import s from './ListingCardBottom.module.css'
import { SvgDot } from './SvgDot'
import { BedroomsSvg } from './BedroomsSvg'
import { BathsSvg } from './BathsSvg'
import { SaveButton } from './components/SaveButton/SaveButton'
import ShareButton from './components/ShareButton/ShareButton/index'
import RequestTour from './components/RequestTour/RequestTour'

function getUnitName(shortAddress) {
  const unitRegex = /Unit:\s*(\d+[A-Za-z]?)/
  const match = shortAddress.match(unitRegex)

  if (match) {
    const unitName = match[1]
    return unitName
  }

  return ''
}

function getShortAddr(shortAddress) {
  const addr = shortAddress.split(' - Unit: ')[0]

  if (addr) {
    return addr
  }

  return ''
}

const ListingCardBottom = (props) => {
  const { listing, signedIn } = props

  const {
    id,
    url,
    price,
    subway_lines: subwayLines,
    bedrooms,
    bathrooms,
    neighborhood,
    short_address: shortAddress,
    square_feet: sqFt,
    meta,
    rental,
    concessions,
    sales_agent: salesAgent,
  } = listing || {}

  let lowestConcession
  let lowestConcessionText

  if (concessions && concessions.length) {
    lowestConcession = concessions
      .filter((concession) => concession.unit_free > 0)
      .filter(
        (concession) =>
          (concession.unit_free <= 12 && concession.unit_type === 'month') ||
          (concession.unit_free <= 52 && concession.unit_type === 'week') ||
          (concession.unit_free <= 365 && concession.unit_type === 'day')
      )
      .filter((concession) => concession.net_effective_rent > 0 && concession.net_effective_rent < price / 100)
      .sort((firstItem, secondItem) => firstItem.net_effective_rent - secondItem.net_effective_rent)
      .shift()

    if (lowestConcession) {
      lowestConcessionText = `${lowestConcession.unit_free} ${lowestConcession.unit_type}${
        lowestConcession.unit_free > 1 ? 's' : ''
      } free`
    }
  }

  const hasLowestConcession = lowestConcession !== undefined
  const priceDefault = accounting.formatMoney(price / 100, { precision: 0 })
  const lowestConcessionPrice =
    hasLowestConcession && accounting.formatMoney(lowestConcession.net_effective_rent, { precision: 0 })

  const neighborhoodName = truncate(neighborhood.name, 25)
  const unitName = getUnitName(shortAddress)
  const shortAddr = getShortAddr(shortAddress)

  return (
    <div className={s.root}>
      <div className={s.rows}>
        <div className={s.topRow}>
          <div className={s.price}>
            {hasLowestConcession ? (
              <div className={s.price}>
                <div className={s.oldPrice}>{priceDefault}</div>{' '}
                <div className={s.newPrice}>{lowestConcessionPrice}</div>
              </div>
            ) : (
              <div className={s.normalPrice}>{priceDefault}</div>
            )}
          </div>

          {hasLowestConcession && <div className={s.hasLowestConcession}>{lowestConcessionText}</div>}
        </div>

        <div className={s.middleRow}>
          <div className={s.middleProps}>
            {unitName && (
              <>
                <div className={s.middleProp}>Unit {unitName}</div>
                <SvgDot />
              </>
            )}

            <div className={s.middleProp}>{bedrooms > 0 ? bedrooms : 1}</div>
            <BedroomsSvg />
            <SvgDot />
            <div className={s.middleProp}>{bathrooms > 0 ? bathrooms : 1}</div>
            <BathsSvg />
          </div>

          <div className={s.subway}>{rental ? <SubwayRow subwayLines={subwayLines} /> : !!sqFt && `${sqFt} sq.ft`}</div>
        </div>

        <div className={s.bottomRow}>
          {shortAddr && <div className={s.address}>{shortAddr}</div>}

          {neighborhood && (
            <>
              <SvgDot />
              <div className={s.neighborhood}>{neighborhoodName}</div>
            </>
          )}
        </div>
      </div>

      <div className={s.buttons}>
        <SaveButton id={id} type="listing" saved={meta.saved} signedIn={signedIn} />
        <ShareButton url={url} />
        <RequestTour propertyId={id} salesAgent={salesAgent} signedIn={signedIn} />
      </div>
    </div>
  )
}

ListingCardBottom.propTypes = {
  listing: PropTypes.shape({
    id: PropTypes.number,
    subway_lines: PropTypes.arrayOf(PropTypes.string),
    url: PropTypes.string,
    price: PropTypes.number,
    bedrooms: PropTypes.number,
    bathrooms: PropTypes.number,
    neighborhood: PropTypes.shape({
      name: PropTypes.string,
    }),
    meta: PropTypes.shape({
      liked: PropTypes.bool,
    }),
    concessions: PropTypes.array,
  }).isRequired,
  signedIn: PropTypes.bool.isRequired,
}

export default ListingCardBottom
